import {
  Companion_getInstance1os58gbbjei8z as Companion_getInstance,
  WebAuthNCredentialoa2waq5o0kvs as WebAuthNCredential,
} from './WebAuthN.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareWebAuthNCredentialFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [WebAuthNCredential__id_getInstance(), WebAuthNCredential_subjectId_getInstance(), WebAuthNCredential_subjectType_getInstance(), WebAuthNCredential_displayName_getInstance(), WebAuthNCredential_residentKey_getInstance(), WebAuthNCredential_authenticatorAttachment_getInstance(), WebAuthNCredential_attestationObject_getInstance(), WebAuthNCredential_lastSignCount_getInstance(), WebAuthNCredential_transports_getInstance(), WebAuthNCredential_establishedAt_getInstance(), WebAuthNCredential_lastUsedAt_getInstance(), WebAuthNCredential_expiresAt_getInstance(), WebAuthNCredential_disabledAt_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function WebAuthNCredential__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function WebAuthNCredential__id$_get_name_$ref_drb4vj() {
  return (p0) => p0.i20();
}
function WebAuthNCredential__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential__id$_get_serializer_$ref_45qyvc() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function WebAuthNCredential__id$_get_annotations_$ref_t7p5hg() {
  return (p0) => p0.bz();
}
var WebAuthNCredential__idClass;
function WebAuthNCredential__id() {
  if (WebAuthNCredential__idClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential__id_instance = this;
        var tmp = this;
        tmp.f2w_1 = lazy(WebAuthNCredential__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g2w_1 = lazy(WebAuthNCredential__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h2w_1 = lazy(WebAuthNCredential__id$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.f2w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential__id$_get_name_$ref_drb4vj(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.j2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      w2w(receiver, value) {
        return receiver.x2w(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.w2w(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.g2w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential__id$_get_serializer_$ref_45qyvc(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h2w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential__id$_get_annotations_$ref_t7p5hg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential__id', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential__idClass = $;
  }
  return WebAuthNCredential__idClass;
}
var WebAuthNCredential__id_instance;
function WebAuthNCredential__id_getInstance() {
  if (WebAuthNCredential__id_instance === VOID)
    new (WebAuthNCredential__id())();
  return WebAuthNCredential__id_instance;
}
function WebAuthNCredential_subjectId$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function WebAuthNCredential_subjectId$_get_name_$ref_698g9q() {
  return (p0) => p0.i20();
}
function WebAuthNCredential_subjectId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential_subjectId$_get_serializer_$ref_1upc79() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential_subjectId$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function WebAuthNCredential_subjectId$_get_annotations_$ref_2ieis7() {
  return (p0) => p0.bz();
}
var WebAuthNCredential_subjectIdClass;
function WebAuthNCredential_subjectId() {
  if (WebAuthNCredential_subjectIdClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential_subjectId_instance = this;
        var tmp = this;
        tmp.y2w_1 = lazy(WebAuthNCredential_subjectId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z2w_1 = lazy(WebAuthNCredential_subjectId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a2x_1 = lazy(WebAuthNCredential_subjectId$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.y2w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential_subjectId$_get_name_$ref_698g9q(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.k2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      w2w(receiver, value) {
        return receiver.x2w(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.w2w(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.z2w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential_subjectId$_get_serializer_$ref_1upc79(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential_subjectId$_get_annotations_$ref_2ieis7(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential_subjectId', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential_subjectIdClass = $;
  }
  return WebAuthNCredential_subjectIdClass;
}
var WebAuthNCredential_subjectId_instance;
function WebAuthNCredential_subjectId_getInstance() {
  if (WebAuthNCredential_subjectId_instance === VOID)
    new (WebAuthNCredential_subjectId())();
  return WebAuthNCredential_subjectId_instance;
}
function WebAuthNCredential_subjectType$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function WebAuthNCredential_subjectType$_get_name_$ref_g5q5nn() {
  return (p0) => p0.i20();
}
function WebAuthNCredential_subjectType$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential_subjectType$_get_serializer_$ref_n08nyc() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential_subjectType$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function WebAuthNCredential_subjectType$_get_annotations_$ref_j015bs() {
  return (p0) => p0.bz();
}
var WebAuthNCredential_subjectTypeClass;
function WebAuthNCredential_subjectType() {
  if (WebAuthNCredential_subjectTypeClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential_subjectType_instance = this;
        var tmp = this;
        tmp.b2x_1 = lazy(WebAuthNCredential_subjectType$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c2x_1 = lazy(WebAuthNCredential_subjectType$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d2x_1 = lazy(WebAuthNCredential_subjectType$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.b2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential_subjectType$_get_name_$ref_g5q5nn(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.l2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      w2w(receiver, value) {
        return receiver.x2w(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.w2w(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.c2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential_subjectType$_get_serializer_$ref_n08nyc(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential_subjectType$_get_annotations_$ref_j015bs(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential_subjectType', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential_subjectTypeClass = $;
  }
  return WebAuthNCredential_subjectTypeClass;
}
var WebAuthNCredential_subjectType_instance;
function WebAuthNCredential_subjectType_getInstance() {
  if (WebAuthNCredential_subjectType_instance === VOID)
    new (WebAuthNCredential_subjectType())();
  return WebAuthNCredential_subjectType_instance;
}
function WebAuthNCredential_displayName$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function WebAuthNCredential_displayName$_get_name_$ref_lrsqqk() {
  return (p0) => p0.i20();
}
function WebAuthNCredential_displayName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential_displayName$_get_serializer_$ref_lylvzp() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential_displayName$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function WebAuthNCredential_displayName$_get_annotations_$ref_pf4zfz() {
  return (p0) => p0.bz();
}
var WebAuthNCredential_displayNameClass;
function WebAuthNCredential_displayName() {
  if (WebAuthNCredential_displayNameClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential_displayName_instance = this;
        var tmp = this;
        tmp.e2x_1 = lazy(WebAuthNCredential_displayName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f2x_1 = lazy(WebAuthNCredential_displayName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g2x_1 = lazy(WebAuthNCredential_displayName$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.e2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential_displayName$_get_name_$ref_lrsqqk(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.m2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      w2w(receiver, value) {
        return receiver.x2w(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.w2w(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.f2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential_displayName$_get_serializer_$ref_lylvzp(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential_displayName$_get_annotations_$ref_pf4zfz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential_displayName', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential_displayNameClass = $;
  }
  return WebAuthNCredential_displayNameClass;
}
var WebAuthNCredential_displayName_instance;
function WebAuthNCredential_displayName_getInstance() {
  if (WebAuthNCredential_displayName_instance === VOID)
    new (WebAuthNCredential_displayName())();
  return WebAuthNCredential_displayName_instance;
}
function WebAuthNCredential_residentKey$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function WebAuthNCredential_residentKey$_get_name_$ref_6h5b4q() {
  return (p0) => p0.i20();
}
function WebAuthNCredential_residentKey$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential_residentKey$_get_serializer_$ref_hyaxvx() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential_residentKey$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function WebAuthNCredential_residentKey$_get_annotations_$ref_4e7t73() {
  return (p0) => p0.bz();
}
var WebAuthNCredential_residentKeyClass;
function WebAuthNCredential_residentKey() {
  if (WebAuthNCredential_residentKeyClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential_residentKey_instance = this;
        var tmp = this;
        tmp.h2x_1 = lazy(WebAuthNCredential_residentKey$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i2x_1 = lazy(WebAuthNCredential_residentKey$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j2x_1 = lazy(WebAuthNCredential_residentKey$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.h2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential_residentKey$_get_name_$ref_6h5b4q(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.n2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      k2x(receiver, value) {
        return receiver.x2w(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.k2x(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.i2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential_residentKey$_get_serializer_$ref_hyaxvx(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential_residentKey$_get_annotations_$ref_4e7t73(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential_residentKey', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential_residentKeyClass = $;
  }
  return WebAuthNCredential_residentKeyClass;
}
var WebAuthNCredential_residentKey_instance;
function WebAuthNCredential_residentKey_getInstance() {
  if (WebAuthNCredential_residentKey_instance === VOID)
    new (WebAuthNCredential_residentKey())();
  return WebAuthNCredential_residentKey_instance;
}
function WebAuthNCredential_authenticatorAttachment$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function WebAuthNCredential_authenticatorAttachment$_get_name_$ref_8ulydp() {
  return (p0) => p0.i20();
}
function WebAuthNCredential_authenticatorAttachment$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential_authenticatorAttachment$_get_serializer_$ref_fjbk24() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential_authenticatorAttachment$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function WebAuthNCredential_authenticatorAttachment$_get_annotations_$ref_voj6iw() {
  return (p0) => p0.bz();
}
var WebAuthNCredential_authenticatorAttachmentClass;
function WebAuthNCredential_authenticatorAttachment() {
  if (WebAuthNCredential_authenticatorAttachmentClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential_authenticatorAttachment_instance = this;
        var tmp = this;
        tmp.l2x_1 = lazy(WebAuthNCredential_authenticatorAttachment$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m2x_1 = lazy(WebAuthNCredential_authenticatorAttachment$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n2x_1 = lazy(WebAuthNCredential_authenticatorAttachment$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.l2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential_authenticatorAttachment$_get_name_$ref_8ulydp(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.o2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      w2w(receiver, value) {
        return receiver.x2w(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.w2w(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential_authenticatorAttachment$_get_serializer_$ref_fjbk24(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential_authenticatorAttachment$_get_annotations_$ref_voj6iw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential_authenticatorAttachment', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential_authenticatorAttachmentClass = $;
  }
  return WebAuthNCredential_authenticatorAttachmentClass;
}
var WebAuthNCredential_authenticatorAttachment_instance;
function WebAuthNCredential_authenticatorAttachment_getInstance() {
  if (WebAuthNCredential_authenticatorAttachment_instance === VOID)
    new (WebAuthNCredential_authenticatorAttachment())();
  return WebAuthNCredential_authenticatorAttachment_instance;
}
function WebAuthNCredential_attestationObject$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function WebAuthNCredential_attestationObject$_get_name_$ref_skuy8q() {
  return (p0) => p0.i20();
}
function WebAuthNCredential_attestationObject$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential_attestationObject$_get_serializer_$ref_7o7lf7() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential_attestationObject$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function WebAuthNCredential_attestationObject$_get_annotations_$ref_8ni7n5() {
  return (p0) => p0.bz();
}
var WebAuthNCredential_attestationObjectClass;
function WebAuthNCredential_attestationObject() {
  if (WebAuthNCredential_attestationObjectClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential_attestationObject_instance = this;
        var tmp = this;
        tmp.o2x_1 = lazy(WebAuthNCredential_attestationObject$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p2x_1 = lazy(WebAuthNCredential_attestationObject$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q2x_1 = lazy(WebAuthNCredential_attestationObject$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.o2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential_attestationObject$_get_name_$ref_skuy8q(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.p2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      w2w(receiver, value) {
        return receiver.x2w(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.w2w(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.p2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential_attestationObject$_get_serializer_$ref_7o7lf7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential_attestationObject$_get_annotations_$ref_8ni7n5(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential_attestationObject', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential_attestationObjectClass = $;
  }
  return WebAuthNCredential_attestationObjectClass;
}
var WebAuthNCredential_attestationObject_instance;
function WebAuthNCredential_attestationObject_getInstance() {
  if (WebAuthNCredential_attestationObject_instance === VOID)
    new (WebAuthNCredential_attestationObject())();
  return WebAuthNCredential_attestationObject_instance;
}
function WebAuthNCredential_lastSignCount$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function WebAuthNCredential_lastSignCount$_get_name_$ref_utrthp() {
  return (p0) => p0.i20();
}
function WebAuthNCredential_lastSignCount$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential_lastSignCount$_get_serializer_$ref_a9i61y() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential_lastSignCount$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function WebAuthNCredential_lastSignCount$_get_annotations_$ref_hyhx9a() {
  return (p0) => p0.bz();
}
var WebAuthNCredential_lastSignCountClass;
function WebAuthNCredential_lastSignCount() {
  if (WebAuthNCredential_lastSignCountClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential_lastSignCount_instance = this;
        var tmp = this;
        tmp.r2x_1 = lazy(WebAuthNCredential_lastSignCount$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s2x_1 = lazy(WebAuthNCredential_lastSignCount$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t2x_1 = lazy(WebAuthNCredential_lastSignCount$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.r2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential_lastSignCount$_get_name_$ref_utrthp(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.q2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      u2x(receiver, value) {
        return receiver.x2w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.u2x(tmp, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential_lastSignCount$_get_serializer_$ref_a9i61y(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential_lastSignCount$_get_annotations_$ref_hyhx9a(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential_lastSignCount', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential_lastSignCountClass = $;
  }
  return WebAuthNCredential_lastSignCountClass;
}
var WebAuthNCredential_lastSignCount_instance;
function WebAuthNCredential_lastSignCount_getInstance() {
  if (WebAuthNCredential_lastSignCount_instance === VOID)
    new (WebAuthNCredential_lastSignCount())();
  return WebAuthNCredential_lastSignCount_instance;
}
function WebAuthNCredential_transports$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(8);
}
function WebAuthNCredential_transports$_get_name_$ref_7pzqmr() {
  return (p0) => p0.i20();
}
function WebAuthNCredential_transports$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential_transports$_get_serializer_$ref_syddqs() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential_transports$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(8);
}
function WebAuthNCredential_transports$_get_annotations_$ref_9p8t3s() {
  return (p0) => p0.bz();
}
var WebAuthNCredential_transportsClass;
function WebAuthNCredential_transports() {
  if (WebAuthNCredential_transportsClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential_transports_instance = this;
        var tmp = this;
        tmp.v2x_1 = lazy(WebAuthNCredential_transports$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w2x_1 = lazy(WebAuthNCredential_transports$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x2x_1 = lazy(WebAuthNCredential_transports$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.v2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential_transports$_get_name_$ref_7pzqmr(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.r2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      y2x(receiver, value) {
        return receiver.x2w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.y2x(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.w2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential_transports$_get_serializer_$ref_syddqs(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential_transports$_get_annotations_$ref_9p8t3s(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential_transports', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential_transportsClass = $;
  }
  return WebAuthNCredential_transportsClass;
}
var WebAuthNCredential_transports_instance;
function WebAuthNCredential_transports_getInstance() {
  if (WebAuthNCredential_transports_instance === VOID)
    new (WebAuthNCredential_transports())();
  return WebAuthNCredential_transports_instance;
}
function WebAuthNCredential_establishedAt$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(9);
}
function WebAuthNCredential_establishedAt$_get_name_$ref_flswim() {
  return (p0) => p0.i20();
}
function WebAuthNCredential_establishedAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential_establishedAt$_get_serializer_$ref_avbaif() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential_establishedAt$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(9);
}
function WebAuthNCredential_establishedAt$_get_annotations_$ref_yajaj7() {
  return (p0) => p0.bz();
}
var WebAuthNCredential_establishedAtClass;
function WebAuthNCredential_establishedAt() {
  if (WebAuthNCredential_establishedAtClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential_establishedAt_instance = this;
        var tmp = this;
        tmp.z2x_1 = lazy(WebAuthNCredential_establishedAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a2y_1 = lazy(WebAuthNCredential_establishedAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b2y_1 = lazy(WebAuthNCredential_establishedAt$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.c2y_1 = get_default(Companion_instance).b1m();
        this.d2y_1 = 'now()';
      }
      i20() {
        var tmp0 = this.z2x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential_establishedAt$_get_name_$ref_flswim(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.s2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      e2y(receiver, value) {
        return receiver.x2w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.e2y(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.a2y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential_establishedAt$_get_serializer_$ref_avbaif(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b2y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential_establishedAt$_get_annotations_$ref_yajaj7(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential_establishedAt', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential_establishedAtClass = $;
  }
  return WebAuthNCredential_establishedAtClass;
}
var WebAuthNCredential_establishedAt_instance;
function WebAuthNCredential_establishedAt_getInstance() {
  if (WebAuthNCredential_establishedAt_instance === VOID)
    new (WebAuthNCredential_establishedAt())();
  return WebAuthNCredential_establishedAt_instance;
}
function WebAuthNCredential_lastUsedAt$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(10);
}
function WebAuthNCredential_lastUsedAt$_get_name_$ref_8mkz9l() {
  return (p0) => p0.i20();
}
function WebAuthNCredential_lastUsedAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential_lastUsedAt$_get_serializer_$ref_w5bk6o() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential_lastUsedAt$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(10);
}
function WebAuthNCredential_lastUsedAt$_get_annotations_$ref_i92olo() {
  return (p0) => p0.bz();
}
var WebAuthNCredential_lastUsedAtClass;
function WebAuthNCredential_lastUsedAt() {
  if (WebAuthNCredential_lastUsedAtClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential_lastUsedAt_instance = this;
        var tmp = this;
        tmp.f2y_1 = lazy(WebAuthNCredential_lastUsedAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g2y_1 = lazy(WebAuthNCredential_lastUsedAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h2y_1 = lazy(WebAuthNCredential_lastUsedAt$annotations$delegate$lambda);
        this.i2y_1 = null;
        this.j2y_1 = 'null';
      }
      i20() {
        var tmp0 = this.f2y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential_lastUsedAt$_get_name_$ref_8mkz9l(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.t2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      k2y(receiver, value) {
        return receiver.x2w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.k2y(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.g2y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential_lastUsedAt$_get_serializer_$ref_w5bk6o(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h2y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential_lastUsedAt$_get_annotations_$ref_i92olo(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential_lastUsedAt', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential_lastUsedAtClass = $;
  }
  return WebAuthNCredential_lastUsedAtClass;
}
var WebAuthNCredential_lastUsedAt_instance;
function WebAuthNCredential_lastUsedAt_getInstance() {
  if (WebAuthNCredential_lastUsedAt_instance === VOID)
    new (WebAuthNCredential_lastUsedAt())();
  return WebAuthNCredential_lastUsedAt_instance;
}
function WebAuthNCredential_expiresAt$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(11);
}
function WebAuthNCredential_expiresAt$_get_name_$ref_yj3r7m() {
  return (p0) => p0.i20();
}
function WebAuthNCredential_expiresAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential_expiresAt$_get_serializer_$ref_sjdw6d() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential_expiresAt$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(11);
}
function WebAuthNCredential_expiresAt$_get_annotations_$ref_mlsxop() {
  return (p0) => p0.bz();
}
var WebAuthNCredential_expiresAtClass;
function WebAuthNCredential_expiresAt() {
  if (WebAuthNCredential_expiresAtClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential_expiresAt_instance = this;
        var tmp = this;
        tmp.l2y_1 = lazy(WebAuthNCredential_expiresAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m2y_1 = lazy(WebAuthNCredential_expiresAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n2y_1 = lazy(WebAuthNCredential_expiresAt$annotations$delegate$lambda);
        this.o2y_1 = null;
        this.p2y_1 = 'null';
      }
      i20() {
        var tmp0 = this.l2y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential_expiresAt$_get_name_$ref_yj3r7m(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.u2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      k2y(receiver, value) {
        return receiver.x2w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.k2y(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m2y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential_expiresAt$_get_serializer_$ref_sjdw6d(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n2y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential_expiresAt$_get_annotations_$ref_mlsxop(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential_expiresAt', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential_expiresAtClass = $;
  }
  return WebAuthNCredential_expiresAtClass;
}
var WebAuthNCredential_expiresAt_instance;
function WebAuthNCredential_expiresAt_getInstance() {
  if (WebAuthNCredential_expiresAt_instance === VOID)
    new (WebAuthNCredential_expiresAt())();
  return WebAuthNCredential_expiresAt_instance;
}
function WebAuthNCredential_disabledAt$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(12);
}
function WebAuthNCredential_disabledAt$_get_name_$ref_3x7lgy() {
  return (p0) => p0.i20();
}
function WebAuthNCredential_disabledAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[12];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function WebAuthNCredential_disabledAt$_get_serializer_$ref_6yiza1() {
  return (p0) => p0.h2j();
}
function WebAuthNCredential_disabledAt$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(12);
}
function WebAuthNCredential_disabledAt$_get_annotations_$ref_iqpa83() {
  return (p0) => p0.bz();
}
var WebAuthNCredential_disabledAtClass;
function WebAuthNCredential_disabledAt() {
  if (WebAuthNCredential_disabledAtClass === VOID) {
    class $ {
      constructor() {
        WebAuthNCredential_disabledAt_instance = this;
        var tmp = this;
        tmp.q2y_1 = lazy(WebAuthNCredential_disabledAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r2y_1 = lazy(WebAuthNCredential_disabledAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s2y_1 = lazy(WebAuthNCredential_disabledAt$annotations$delegate$lambda);
        this.t2y_1 = null;
        this.u2y_1 = 'null';
      }
      i20() {
        var tmp0 = this.q2y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, WebAuthNCredential_disabledAt$_get_name_$ref_3x7lgy(), null);
        return tmp0.f2();
      }
      i2w(receiver) {
        return receiver.v2w_1;
      }
      k2j(receiver) {
        return this.i2w(receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE());
      }
      k2y(receiver, value) {
        return receiver.x2w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof WebAuthNCredential() ? receiver : THROW_CCE();
        return this.k2y(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r2y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, WebAuthNCredential_disabledAt$_get_serializer_$ref_6yiza1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s2y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, WebAuthNCredential_disabledAt$_get_annotations_$ref_iqpa83(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'WebAuthNCredential_disabledAt', VOID, VOID, [SerializableProperty()]);
    WebAuthNCredential_disabledAtClass = $;
  }
  return WebAuthNCredential_disabledAtClass;
}
var WebAuthNCredential_disabledAt_instance;
function WebAuthNCredential_disabledAt_getInstance() {
  if (WebAuthNCredential_disabledAt_instance === VOID)
    new (WebAuthNCredential_disabledAt())();
  return WebAuthNCredential_disabledAt_instance;
}
//region block: exports
export {
  prepareWebAuthNCredentialFields as prepareWebAuthNCredentialFields19ow30dgtlau4,
};
//endregion

//# sourceMappingURL=WebAuthNCredentialFields.mjs.map
